(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["FerroBonus-MiniApp"] = factory();
	else
		root["FerroBonus-MiniApp"] = factory();
})(globalThis, () => {
return 